import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "widget-container" }
const _hoisted_2 = { class: "d-flex row pt-2" }
const _hoisted_3 = { class: "d-flex col-6" }
const _hoisted_4 = { class: "chart-container" }
const _hoisted_5 = {
  class: "progress-svg",
  width: "150",
  height: "150",
  viewBox: "0 0 36 36"
}
const _hoisted_6 = ["stroke-dasharray"]
const _hoisted_7 = ["stroke-dasharray"]
const _hoisted_8 = ["stroke-dasharray"]
const _hoisted_9 = ["stroke-dasharray"]
const _hoisted_10 = ["stroke-dasharray"]
const _hoisted_11 = ["stroke-dasharray"]
const _hoisted_12 = { class: "inner-circle" }
const _hoisted_13 = { class: "progress-text" }
const _hoisted_14 = { class: "health-index-container" }
const _hoisted_15 = { class: "health-index-label" }
const _hoisted_16 = { class: "health-index-progress" }
const _hoisted_17 = { class: "contaccordion" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "lipid-profile-container" }
const _hoisted_20 = { class: "lipid-parameter-row" }
const _hoisted_21 = { class: "lipid-parameter-value" }
const _hoisted_22 = { class: "lipid-parameter-row" }
const _hoisted_23 = { class: "lipid-parameter-value" }
const _hoisted_24 = { class: "lipid-parameter-row" }
const _hoisted_25 = { class: "lipid-parameter-value" }
const _hoisted_26 = { class: "lipid-description mt-3" }
const _hoisted_27 = {
  key: 1,
  class: "m-0"
}
const _hoisted_28 = {
  class: "d-grid py-3 py-md-5",
  style: {"width":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccordionHeader = _resolveComponent("AccordionHeader")!
  const _component_AccordionContent = _resolveComponent("AccordionContent")!
  const _component_AccordionPanel = _resolveComponent("AccordionPanel")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(), _createElementBlock("svg", _hoisted_5, [
            _createElementVNode("circle", {
              class: "progress-circle sleep",
              cx: "18",
              cy: "18",
              r: "15.91549431",
              "stroke-dasharray": `${_ctx.vascularRiskPercent}, 100`
            }, null, 8, _hoisted_6),
            _createElementVNode("circle", {
              class: "progress-circle sleep2",
              cx: "18",
              cy: "18",
              r: "15.91549431",
              "stroke-dasharray": `${(_ctx.vascularRiskPercent * 30) / 100}, 100`
            }, null, 8, _hoisted_7),
            _createElementVNode("circle", {
              class: "progress-circle read",
              cx: "18",
              cy: "18",
              r: "15.91549431",
              "stroke-dasharray": `${_ctx.riskFactorsPercent}, 100`
            }, null, 8, _hoisted_8),
            _createElementVNode("circle", {
              class: "progress-circle read2",
              cx: "18",
              cy: "18",
              r: "15.91549431",
              "stroke-dasharray": `${(_ctx.riskFactorsPercent * 30) / 100}, 100`
            }, null, 8, _hoisted_9),
            _createElementVNode("circle", {
              class: "progress-circle exercise",
              cx: "18",
              cy: "18",
              r: "15.91549431",
              "stroke-dasharray": `${_ctx.lipidMetabolismPercent}, 100`
            }, null, 8, _hoisted_10),
            _createElementVNode("circle", {
              class: "progress-circle exercise2",
              cx: "18",
              cy: "18",
              r: "15.91549431",
              "stroke-dasharray": `${_ctx.lipidMetabolismPercent * 0.3}, 100`
            }, null, 8, _hoisted_11)
          ])),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.totalProgress), 1)
          ])
        ])
      ]),
      _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"d-flex col-6 ms-2\" data-v-f7c22566><ul class=\"widget-legend\" data-v-f7c22566><li data-v-f7c22566><span class=\"legend-dot sleep\" data-v-f7c22566></span> Сосудистый риск</li><li data-v-f7c22566><span class=\"legend-dot read\" data-v-f7c22566></span> Факторы риска</li><li data-v-f7c22566><span class=\"legend-dot exercise\" data-v-f7c22566></span> Липидный обмен</li></ul></div>", 1))
    ]),
    _createElementVNode("div", {
      class: "ps-2 pe-2 pe-0 py-2 mt-4 blocktext",
      style: _normalizeStyle('border-left: 10px solid ' + _ctx.warningColor)
    }, [
      _createTextVNode(_toDisplayString(_ctx.warningMessage) + " ", 1),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, " Health Index: " + _toDisplayString(100 - Math.round((_ctx.healthIndex / 140) * 100)) + "/100 ", 1),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", {
            class: "health-index-bar",
            style: _normalizeStyle({
              width: 100 - Math.round((_ctx.healthIndex / 140) * 100) + '%',
              backgroundColor: _ctx.warningColor,
            })
          }, null, 4)
        ])
      ])
    ], 4),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_Accordion, {
        value: "null",
        activeIndex: _ctx.activeAccordion,
        onTabOpen: _ctx.handleTabOpen
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
            return (_openBlock(), _createBlock(_component_AccordionPanel, {
              key: tab.title,
              value: tab.value
            }, {
              default: _withCtx(() => [
                _createVNode(_component_AccordionHeader, {
                  style: _normalizeStyle('color:' + tab.color)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(tab.title), 1)
                  ]),
                  _: 2
                }, 1032, ["style"]),
                _createVNode(_component_AccordionContent, null, {
                  default: _withCtx(() => [
                    (tab.value === '2' && tab.lipidData)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "lipid-parameter-name" }, "ЛПНП", -1)),
                              _createElementVNode("div", _hoisted_21, _toDisplayString(tab.lipidData.lpnp.value
                        ? tab.lipidData.lpnp.value.toFixed(1)
                        : "Нет данных"), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass(["lipid-parameter-status", {
                      'status-high': tab.lipidData.lpnp.risk === 'high',
                      'status-normal': tab.lipidData.lpnp.risk === 'low',
                      'status-unknown': tab.lipidData.lpnp.risk === 'unknown',
                    }])
                              }, _toDisplayString(tab.lipidData.lpnp.risk === "high"
                        ? "Высокий"
                        : tab.lipidData.lpnp.risk === "low"
                        ? "Не повышен"
                        : "Нет данных"), 3)
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "lipid-parameter-name" }, "ЛПВП", -1)),
                              _createElementVNode("div", _hoisted_23, _toDisplayString(tab.lipidData.lpvp.value
                        ? tab.lipidData.lpvp.value.toFixed(1)
                        : "Нет данных"), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass(["lipid-parameter-status", {
                      'status-low': tab.lipidData.lpvp.risk === 'low',
                      'status-normal': tab.lipidData.lpvp.risk === 'normal',
                      'status-unknown': tab.lipidData.lpvp.risk === 'unknown',
                    }])
                              }, _toDisplayString(tab.lipidData.lpvp.risk === "low"
                        ? "Снижен"
                        : tab.lipidData.lpvp.risk === "normal"
                        ? "Не снижен"
                        : "Нет данных"), 3)
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "lipid-parameter-name" }, "Триглицериды", -1)),
                              _createElementVNode("div", _hoisted_25, _toDisplayString(tab.lipidData.tg.value
                        ? tab.lipidData.tg.value.toFixed(1)
                        : "Нет данных"), 1),
                              _createElementVNode("div", {
                                class: _normalizeClass(["lipid-parameter-status", {
                      'status-high': tab.lipidData.tg.risk === 'high',
                      'status-normal': tab.lipidData.tg.risk === 'low',
                      'status-unknown': tab.lipidData.tg.risk === 'unknown',
                    }])
                              }, _toDisplayString(tab.lipidData.tg.risk === "high"
                        ? "Высокий"
                        : tab.lipidData.tg.risk === "low"
                        ? "Не повышен"
                        : "Нет данных"), 3)
                            ]),
                            _createElementVNode("div", _hoisted_26, _toDisplayString(tab.content), 1)
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(tab.content), 1))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["activeIndex", "onTabOpen"])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createVNode(_component_Button, {
        label: "Пройти опрос заново",
        severity: "primary",
        style: {"background-color":"#4baf50"},
        rounded: "",
        raised: "",
        onClick: _ctx.resetAndNavigate
      }, null, 8, ["onClick"])
    ])
  ]))
}